import Zero from './Countdown-0.svg';
import One from './Countdown-1.svg';
import Ten from './Countdown-10.svg';
import Eleven from './Countdown-11.svg';
import Twelve from './Countdown-12.svg';
import Thirteen from './Countdown-13.svg';
import Fourteen from './Countdown-14.svg';
import Fifteen from './Countdown-15.svg';
import Sixteen from './Countdown-16.svg';
import Seventeen from './Countdown-17.svg';
import Eighteen from './Countdown-18.svg';
import Nineteen from './Countdown-19.svg';
import Two from './Countdown-2.svg';
import Twenty from './Countdown-20.svg';
import TwentyOne from './Countdown-21.svg';
import TwentyTwo from './Countdown-22.svg';
import TwentyThree from './Countdown-23.svg';
import TwentyFour from './Countdown-24.svg';
import TwentyFive from './Countdown-25.svg';
import TwentySix from './Countdown-26.svg';
import TwentySeven from './Countdown-27.svg';
import TwentyEight from './Countdown-28.svg';
import TwentyNine from './Countdown-29.svg';
import Three from './Countdown-3.svg';
import Thirty from './Countdown-30.svg';
import ThirtyOne from './Countdown-31.svg';
import ThirtyTwo from './Countdown-32.svg';
import ThirtyThree from './Countdown-33.svg';
import ThirtyFour from './Countdown-34.svg';
import ThirtyFive from './Countdown-35.svg';
import ThirtySix from './Countdown-36.svg';
import ThirtySeven from './Countdown-37.svg';
import ThirtyEight from './Countdown-38.svg';
import ThirtyNine from './Countdown-39.svg';
import Four from './Countdown-4.svg';
import Forty from './Countdown-40.svg';
import FortyOne from './Countdown-41.svg';
import FortyTwo from './Countdown-42.svg';
import FortyThree from './Countdown-43.svg';
import FortyFour from './Countdown-44.svg';
import FortyFive from './Countdown-45.svg';
import FortySix from './Countdown-46.svg';
import FortySeven from './Countdown-47.svg';
import FortyEight from './Countdown-48.svg';
import FortyNine from './Countdown-49.svg';
import Five from './Countdown-5.svg';
import Fifty from './Countdown-50.svg';
import FiftyOne from './Countdown-51.svg';
import FiftyTwo from './Countdown-52.svg';
import FiftyThree from './Countdown-53.svg';
import FiftyFour from './Countdown-54.svg';
import FiftyFive from './Countdown-55.svg';
import FiftySix from './Countdown-56.svg';
import FiftySeven from './Countdown-57.svg';
import FiftyEight from './Countdown-58.svg';
import FiftyNine from './Countdown-59.svg';
import Six from './Countdown-6.svg';
import Sixty from './Countdown-60.svg';
import SixtyOne from './Countdown-61.svg';
import SixtyTwo from './Countdown-62.svg';
import SixtyThree from './Countdown-63.svg';
import SixtyFour from './Countdown-64.svg';
import SixtyFive from './Countdown-65.svg';
import SixtySix from './Countdown-66.svg';
import SixtySeven from './Countdown-67.svg';
import SixtyEight from './Countdown-68.svg';
import SixtyNine from './Countdown-69.svg';
import Seven from './Countdown-7.svg';
import Seventy from './Countdown-70.svg';
import SeventyOne from './Countdown-71.svg';
import SeventyTwo from './Countdown-72.svg';
import SeventyThree from './Countdown-73.svg';
import SeventyFour from './Countdown-74.svg';
import SeventyFive from './Countdown-75.svg';
import SeventySix from './Countdown-76.svg';
import SeventySeven from './Countdown-77.svg';
import SeventyEight from './Countdown-78.svg';
import SeventyNine from './Countdown-79.svg';
import Eight from './Countdown-8.svg';
import Eighty from './Countdown-80.svg';
import EightyOne from './Countdown-81.svg';
import EightyTwo from './Countdown-82.svg';
import EightyThree from './Countdown-83.svg';
import EightyFour from './Countdown-84.svg';
import EightyFive from './Countdown-85.svg';
import EightySix from './Countdown-86.svg';
import EightySeven from './Countdown-87.svg';
import EightyEight from './Countdown-88.svg';
import Nine from './Countdown-9.svg';
import Full from './Countdown-Full.svg';

export const CountdownImages = new Map<number | string, string>([
  [0, Zero],
  [1, One],
  [2, Two],
  [3, Three],
  [4, Four],
  [5, Five],
  [6, Six],
  [7, Seven],
  [8, Eight],
  [9, Nine],
  [10, Ten],
  [11, Eleven],
  [12, Twelve],
  [13, Thirteen],
  [14, Fourteen],
  [15, Fifteen],
  [16, Sixteen],
  [17, Seventeen],
  [18, Eighteen],
  [19, Nineteen],
  [20, Twenty],
  [21, TwentyOne],
  [22, TwentyTwo],
  [23, TwentyThree],
  [24, TwentyFour],
  [25, TwentyFive],
  [26, TwentySix],
  [27, TwentySeven],
  [28, TwentyEight],
  [29, TwentyNine],
  [30, Thirty],
  [31, ThirtyOne],
  [32, ThirtyTwo],
  [33, ThirtyThree],
  [34, ThirtyFour],
  [35, ThirtyFive],
  [36, ThirtySix],
  [37, ThirtySeven],
  [38, ThirtyEight],
  [39, ThirtyNine],
  [40, Forty],
  [41, FortyOne],
  [42, FortyTwo],
  [43, FortyThree],
  [44, FortyFour],
  [45, FortyFive],
  [46, FortySix],
  [47, FortySeven],
  [48, FortyEight],
  [49, FortyNine],
  [50, Fifty],
  [51, FiftyOne],
  [52, FiftyTwo],
  [53, FiftyThree],
  [54, FiftyFour],
  [55, FiftyFive],
  [56, FiftySix],
  [57, FiftySeven],
  [58, FiftyEight],
  [59, FiftyNine],
  [60, Sixty],
  [61, SixtyOne],
  [62, SixtyTwo],
  [63, SixtyThree],
  [64, SixtyFour],
  [65, SixtyFive],
  [66, SixtySix],
  [67, SixtySeven],
  [68, SixtyEight],
  [69, SixtyNine],
  [70, Seventy],
  [71, SeventyOne],
  [72, SeventyTwo],
  [73, SeventyThree],
  [74, SeventyFour],
  [75, SeventyFive],
  [76, SeventySix],
  [77, SeventySeven],
  [78, SeventyEight],
  [79, SeventyNine],
  [80, Eighty],
  [81, EightyOne],
  [82, EightyTwo],
  [83, EightyThree],
  [84, EightyFour],
  [85, EightyFive],
  [86, EightySix],
  [87, EightySeven],
  [88, EightyEight],
  ['full', Full],
]);
